import { pm_Product_retrieveAll_order } from '../../../services/api/api';

export const clientColumnDefaultsProducts = {
  generic: [
    {
      id: 'id',
      title: 'ID',
      selected: true,

      type: 'PROPERTY',
      orderId: pm_Product_retrieveAll_order.ID,
      canOrder: true,
    },
    {
      id: 'identifier',
      title: 'lang.globals.identifier',
      selected: false,

      type: 'PROPERTY',
      orderId: pm_Product_retrieveAll_order.IDENTIFIER,
      canOrder: true,
    },
    {
      id: 'depiction',
      title: 'Depiction',
      selected: true,

      type: 'PROPERTY',
    },
    {
      id: 'name',
      title: 'Name',
      selected: true,

      type: 'PROPERTY',
      orderId: pm_Product_retrieveAll_order.NAME,
      canOrder: true,
    },
    {
      id: 'plu',
      title: 'PLU',
      selected: true,

      type: 'PROPERTY',
      orderId: pm_Product_retrieveAll_order.PLU,
      canOrder: true,
    },
    {
      id: 'manufacturer',
      title: 'Manufacturer',
      selected: false,

      type: 'PROPERTY',
      orderId: pm_Product_retrieveAll_order.MANUFACTURER_NAME,
      canOrder: true,
    },
    {
      id: 'asin',
      title: 'ASIN',
      selected: false,

      type: 'PROPERTY',
      orderId: pm_Product_retrieveAll_order.ASIN,
      canOrder: true,
    },
    {
      id: 'gtin',
      title: 'GTIN',
      selected: false,

      type: 'PROPERTY',
      orderId: pm_Product_retrieveAll_order.GTIN,
      canOrder: true,
    },
    {
      id: 'attributes',
      title: 'Attributes',
      selected: false,

      type: 'PROPERTY',
      // orderId: pm_Product_retrieveAll_order.ATTRIBUTES, canOrder: true,
    },
    {
      id: 'categories',
      title: 'Categories',
      selected: false,

      type: 'PROPERTY',
    },
    {
      id: 'color',
      title: 'Color',
      selected: false,

      type: 'PROPERTY',
    },
    {
      id: 'description',
      title: 'Description',
      selected: false,

      type: 'PROPERTY',
    },
    {
      id: 'gtinRepresentation',
      title: 'GTIN Representation',
      selected: false,

      type: 'PROPERTY',
    },
  ],
};
